import React, { useState } from 'react';
import { FiCheckSquare, FiSquare } from 'react-icons/fi';
import { FixedSizeList } from 'react-window';

const SearchDropdownVirtualizedList = ({ value, items, onChoose }) => {
  const [search, setSearch] = useState('');

  let options = items.map((item) => {
    return {
      id: item.id,
      label: item.recomend ? `${item.name} 👍` : `${item.name}`,
    };
  });
  
  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(search.toLowerCase())
  );

  const Option = ({ index, style }) => {
    const option = filteredOptions[index];
    const isChosen = value.indexOf(option.id) !== -1 ? true : false;
    const classCss = isChosen ? `r on` : `r`;

    return (
      <p
        style={style}
        className={classCss}
        onClick={() => handleSelect(option)}
        title={option.id}
      >
        {isChosen ? <FiCheckSquare /> : <FiSquare />}
        {option.label}
      </p>
    );
  };

  const handleSelect = (option) => {
    onChoose(option.id);
  };
  return (
    <div className="dropdown-open" style={{ height: 158, overflow: 'hidden' }}>
      <>
        {/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? (
          <>
            <FixedSizeList
              height={762}
              width="100%"
              itemSize={36}
              itemCount={filteredOptions.length}
            >
              {Option}
            </FixedSizeList>
          </>
        ) : (
          <>
            <FixedSizeList
              height={158}
              width="100%"
              itemSize={20}
              itemCount={filteredOptions.length}
            >
              {Option}
            </FixedSizeList>
          </>
        )}
      </>
    </div>
  );
};

export default SearchDropdownVirtualizedList;
